import React from "react";
import { Col, Row, Layout, Divider } from "antd";
import SectionTitle from "../../component/section_title";
import UserAvatar from "./component/account_avatar";
import AccountFormInfo from "./component/form_info";
import AccountFormMobile from "./component/form_mobile";
import AccountFormEmail from "./component/form_email";
import AccountFormPassword from "./component/form_password";

import "./style.css";

const { Content } = Layout;

const AccountScreen = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full">
      <Content className="content">
        <Row gutter={[16, 16]} justify="center" style={{ marginBottom: 40 }}>
          <Col xxl={12} xl={12} lg={12} md={12} xs={24}>
            <SectionTitle title="Account" subtitle="Basic information about you" />
            <UserAvatar />
            <Divider />
            <AccountFormInfo />
            <Divider />
            <AccountFormMobile />
            <br />
            <AccountFormEmail />
            <Divider />
            <AccountFormPassword />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default AccountScreen;
